import { render, staticRenderFns } from "./post_publish.vue?vue&type=template&id=06ffeac0&scoped=true&"
import script from "./post_publish.vue?vue&type=script&lang=js&"
export * from "./post_publish.vue?vue&type=script&lang=js&"
import style0 from "./post_publish.vue?vue&type=style&index=0&id=06ffeac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffeac0",
  null
  
)

export default component.exports